/**
 * Publishes one class, `paree-scrolled` on <html>, once the page has been scrolled a little.
 * The fixed bottom bars — add to cart on a product page, buy the set / start the plan on those
 * pages — key off it, so the top of a page opens on the photograph and the bar arrives the
 * moment the visitor moves. Each of those pages already has an in-flow buy button beside the
 * price, so a visitor who never scrolls is not stranded; there is no timer.
 *
 * Ours rather than the theme's: Be Yours already publishes `shopify-body-section-header-sticky` at
 * roughly this moment, but only while the header's sticky mode is on. Keying the buy button to a
 * setting in the theme editor means someone turning that off silently takes the bar away.
 *
 * Two scroll thresholds, not one: a single line would flip the class back and forth while a visitor
 * nudges the page around the boundary, and each flip animates a bar in or out. 80px in, 40px out.
 * Scrolling back above 40px parks the bar again — the in-flow button is still there.
 *
 * Deliberately outside paree-progress.js, whose whole module returns early under
 * prefers-reduced-motion — a decorative bar can sit that request out, a buy button cannot.
 * Injected into layout/theme.liquid by theme/apply-brand.mjs.
 */
;(function () {
  var SHOW_AT = 80
  var HIDE_AT = 40
  var CLASS = 'paree-scrolled'

  var root = document.documentElement
  var shown = false
  var ticking = false

  function show() {
    if (shown) return
    shown = true
    root.classList.add(CLASS)
  }

  function park() {
    if (!shown) return
    shown = false
    root.classList.remove(CLASS)
  }

  function update() {
    ticking = false
    var y = window.scrollY || root.scrollTop || 0

    if (y >= SHOW_AT) show()
    else if (y <= HIDE_AT) park()
  }

  function onScroll() {
    if (ticking) return
    ticking = true
    requestAnimationFrame(update)
  }

  // Runs before the first scroll event, because a reload, a back navigation or a link to an anchor
  // can all restore the page part-way down, where the bar has to be there already.
  update()
  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('pageshow', update)
})()
